import { all, call, put, takeEvery } from "redux-saga/effects";
import API from "../../../Utils/api";
import {
  notifyPromise,
} from "../../../Utils/Helper";
import {
  stripePaymentSuccess,
  stripePaymentFailure,
} from "../../Action/payments/stripePaymentAction";
import { STRIPE_PAYMENT } from "../../Action/actionTypes";

function* stripePaymentRequest(action) {
  console.log("action",action)
  try {
    const response = yield notifyPromise(
      API.post(`/stripe-payment`, action?.payload?.payload)
    );

    // Transform the response to ensure it has the correct structure
    const transformedResponse = {
      ...response,
      data: {
        ...response.data,
        data: {
          ...response.data.data,
          paymentURL: response.data.data.url || response.data.data.stripeUrl
        }
      }
    };

    if (action?.payload?.callback) {
      yield call(action.payload.callback, transformedResponse.data);
    }

    if (response?.data?.meta?.code === 200) {
      yield put(stripePaymentSuccess(transformedResponse.data));
    } else {
      yield put(stripePaymentFailure());
    }
  } catch (error) {
    if (action?.payload?.callback) {
      yield call(action.payload.callback, {});
    }
    yield put(stripePaymentFailure());
  }
}

export function* watchStripePaymentAPI() {
  yield takeEvery(STRIPE_PAYMENT, stripePaymentRequest);
}

export default function* rootSaga() {
  yield all([watchStripePaymentAPI()]);
}